import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

export const localStorage = createLocalStorageProvider('cmdb-object-hide-empty-attributes');

export const setHideEmptyAttributes = (shouldHide: boolean, objectTypeId: string) => {
	localStorage.set(`hideEmptyAttributes_${objectTypeId}`, shouldHide);
};

export const getHideEmptyAttributes = (objectTypeId: string): boolean =>
	localStorage.get(`hideEmptyAttributes_${objectTypeId}`) || false;
